import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import ThemeToggle from "../components/ThemeToggle";
import BrandLogo from "../components/BrandLogo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const goDashboard = (res) => {
    if (res.ok) {
      toast.success(res.demo ? "Modo demostración" : "Bienvenido");
      navigate("/app/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    goDashboard(res);
  };

  const enterDemo = async () => {
    setLoading(true);
    const res = await login("demo@aequor.cl", "Prueba123#");
    setLoading(false);
    goDashboard({ ...res, demo: true });
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      <div className="auth-bg hidden lg:flex relative overflow-hidden">
        <div className="absolute inset-0 opacity-40 pointer-events-none" aria-hidden>
          <svg className="w-full h-full" viewBox="0 0 600 900" fill="none">
            <path d="M-20 120 C 140 60, 220 200, 360 140 S 560 80, 640 180" stroke="#B8975F" strokeWidth="1.2" opacity="0.7" />
            <path d="M 40 780 C 180 700, 300 820, 460 740 S 700 680, 760 760" stroke="#B8975F" strokeWidth="1" opacity="0.45" />
          </svg>
        </div>
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-3">
            <BrandLogo className="h-16" onDark testid="login-logo" />
            <div className="flex flex-col leading-none">
              <span className="font-display text-xl tracking-[0.2em] uppercase">Aequor</span>
              <span className="flex items-center gap-2 mt-1.5 text-[#B8975F]">
                <span className="h-px w-4 bg-current" />
                <span className="text-[10px] tracking-[0.35em] uppercase font-semibold">Group</span>
                <span className="h-px w-4 bg-current" />
              </span>
            </div>
          </div>
          <div className="space-y-3 max-w-md">
            <div className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#B8975F]">
              Contabilidad chilena
            </div>
            <h2 className="font-display text-4xl leading-tight text-white">
              La contabilidad de tu empresa, ordenada y al día.
            </h2>
            <p className="text-white/70 text-sm leading-relaxed">
              Plan de cuentas, libro diario, libro mayor, balance general y estado de resultados.
              Multiempresa, multiusuario.
            </p>
          </div>
        </div>
      </div>

      <div className="relative flex items-center justify-center p-8 bg-background">
        <div className="absolute top-4 right-4">
          <ThemeToggle testid="login-theme-toggle" />
        </div>
        <form
          onSubmit={submit}
          autoComplete="off"
          className="w-full max-w-sm bg-card border border-border rounded-md p-8"
          data-testid="login-form"
        >
          <div className="label-caps mb-2">Iniciar sesión</div>
          <h1 className="font-display text-2xl font-medium tracking-tight mb-1">Bienvenido</h1>
          <p className="text-sm text-muted-foreground mb-6">Accede a tu contabilidad.</p>

          <label className="label-caps block mb-1.5" htmlFor="email">Correo</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="off"
            data-testid="login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="demo@aequor.cl"
            className="w-full px-3 py-2 rounded-sm border border-border bg-card placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary text-sm mb-4"
          />

          <label className="label-caps block mb-1.5" htmlFor="password">Contraseña</label>
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="new-password"
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Prueba123#"
            className="w-full px-3 py-2 rounded-sm border border-border bg-card placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary text-sm mb-2"
          />

          <p className="text-right mb-6">
            <Link to="/olvide-contraseña" className="text-sm text-primary underline">
              ¿Olvidó su contraseña?
            </Link>
          </p>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-primary hover:opacity-90 disabled:opacity-60 text-primary-foreground text-sm font-medium py-2.5 rounded-sm transition-opacity"
          >
            {loading ? "Iniciando…" : "Iniciar sesión"}
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={enterDemo}
            data-testid="login-demo-button"
            className="w-full mt-3 border border-gold text-foreground hover:bg-gold/10 disabled:opacity-60 text-sm font-medium py-2.5 rounded-sm transition-colors"
          >
            Ver demostración (solo lectura)
          </button>
        </form>
      </div>
    </div>
  );
}
